import 'whatwg-fetch';
import Cookies from 'js-cookie';
import {logMessageToServer} from '../js/loggerService';

export const getEffectiveLicenses = (orgId) => {
    return fetch(`/license-service/api/v1/OrgLicenseAssignment('${orgId}')/EffectiveLicenses()`, {
        credentials: "same-origin",
        headers: {
            "XSRF_TOKEN": Cookies.get('XSRF_TOKEN')
        }
    }).then(function (response) {
        return response.json();
    }).catch(function(failure) {
        logMessageToServer("ERROR", "TRIAL-LICENSE-SERVICE", "Failed to fetch licenses");
        return [];
    });
};